<template>
	<div id="app">
		
		<type-writer />
		<notebook />
		<notifications />

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import TypeWriter from './components/TypeWriter'
import Notebook from './components/Notebook'
import Notifications from './components/ui/Notifications'

export default {
	name: 'App',
	data: function() {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([  ]), {

	}),
	components: { TypeWriter, Notebook, Notifications }
}
</script>

<style lang="stylus">
// @import url('https://fonts.googleapis.com/css?family=Averia+Libre|Inconsolata:700');
@import './assets/css/app'

@font-face {
	font-family: 'Averia Libre';
	font-style: normal;
	font-weight: 400;
	src: local('Averia Libre Regular'), local('AveriaLibre-Regular'), url(./assets/fonts/averia-libre.woff2) format('woff2');
	unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
	font-family: 'Inconsolata';
	font-style: normal;
	font-weight: 700;
	src: local('Inconsolata Bold'), local('Inconsolata-Bold'), url(./assets/fonts/inconsolata.woff2) format('woff2');
	unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

*
	margin 0
	padding 0
	position relative
	user-select none
	box-sizing border-box
	cursor default

html, body
	height 100%
	width 100%
	font-family 'Inconsolata'
	font-size 16px
	color #333
	overflow hidden
	background #c3e5df
	
#app
	height 100%
	margin 0 auto
	display flex
	align-items flex-end
	justify-content center
	padding 0 0 48px 0
	width 1024px
	// height 880px

@media (max-height: 880px)
	#app
		padding 0 0 8px 0

@media (max-height: 830px)
	#app
		padding 0 0 8px 0
		.keyboard
			height ((48px + 8px) * 4 + 32px)
			.slot
				height 48px
				min-width 48px
				border-radius 16px
				.key
					border-radius 16px
					box-shadow inset 0 -4px 0 0 alpha(dark, 25%)
					.letter
						line-height 44px
		.notebook
			margin 0 0 140px 24px

	
</style>



// WEBPACK FOOTER //
// src/App.vue